import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  FormLabelProps,
  Textarea,
} from "@chakra-ui/react";
import { FieldProps, getIn } from "formik";
import React from "react";

interface Props extends FieldProps {
  label: string;
  labelProps?: FormLabelProps;
  containerProps?: FormControlProps;
}

const ChakraTextArea: React.FC<Props> = ({
  field,
  form,
  label,
  labelProps,
  containerProps,
  ...props
}) => {
  const errorText =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  return (
    <FormControl isInvalid={!!errorText} my="2" {...containerProps}>
      <FormLabel
        fontFamily="Lexend, sans-serif"
        color="gray.700"
        htmlFor={`${field.name}-id`}
        {...labelProps}
      >
        {label}
      </FormLabel>
      <Textarea id={`${field.name}-id`} shadow="sm" {...field} {...props} />
      <FormErrorMessage>{errorText}</FormErrorMessage>
    </FormControl>
  );
};

export default ChakraTextArea;
